import { Menu } from "Components/menuGeneric";
import React, { useEffect, useState } from "react";
import buildSettingsMenuItems from "./settingsMenuItems/buildSettingsMenuItems";
import SettingsToggler from "./settingsToggler";
export default function Settings(props) {
    const [menuItems, setMenuItems] = useState([]);
    useEffect(() => {
        setMenuItems(buildSettingsMenuItems());
    }, []);
    return (React.createElement(Menu, { className: props.className, zIndex: props.zIndex, menuToggler: SettingsToggler, menuItems: menuItems }));
}
